export const contentModerationData = {
  ContentModeration: {
    Title: "Content Moderation",
    GeneralTopData: [
      "Content Moderation on ESQUADIFI",
      "To ensure a respectful and enjoyable live stream experience, ESQUADIFI allows organisers to moderate their events or assign community members as moderators.",
    ],
    GeneralBottomData: [""],
    Steps: [
      {
        StepTitle: "Moderator Capabilities",
        Description: [
          "Remove chat messages.",
          "Ban or unban audience members.",
        ],
      },
      {
        StepTitle: "Adding/Removing Moderators",
        Description: [
          "Via Chat Command:",
          "Add Moderator: Type /mod <username>.",
          "Remove Moderator: Type /unmod <username>.",
          "Via Creator Dashboard:",
          "Go to the 'Moderators' section in your dashboard.",
          "Add Moderator: Click 'Add new,' enter the username, and click 'Add.'",
          "Remove Moderator: Find the user and click 'Remove.'",
        ],
      },
      {
        StepTitle: "Managing Chat Messages",
        Description: [
          "Remove Messages: Hover over the message and click the trashcan icon labeled 'Delete.'",
          "Ban Users:",
          "Using UI: Hover over the user, click their username, and select 'Ban.'",
          "Using Command: Type /ban <username>.",
          "Timeout Users: Temporarily prevent a user from chatting by typing /timeout <username> <time> <reason>.",
        ],
      },
      {
        StepTitle: "Reporting Users",
        Description: [
          "Click the username of the user.",
          "Select the 'Report' icon.",
          "Provide details and click 'Report.'",
        ],
      },
      {
        StepTitle: "Responsibilities of Organisers",
        Description: [
          "Organisers must maintain a respectful environment during events.",
          "Manage moderators via the ongoing events dashboard.",
          "Actively monitor the chat to ensure a positive experience for all participants.",
        ],
      },
    ],
  },
};
